import { baseApi } from "api/BaseApi";

import {
  ProgressPoint,
  ProgressPointUpdate,
  ProgressPointUpdateApiResponse,
  GroupedProgressPoints,
} from "./progressPoints.types";

const PROGRESS_POINTS_BASE_URL = "project/progress";

const progressPointsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getProgressPointsByPid: build.query<ProgressPoint[], string | number>({
      query: (pid) => ({
        url: `${PROGRESS_POINTS_BASE_URL}/progress_points_by_pid/`,
        params: { pid },
      }),

      transformResponse: (response: ProgressPoint[]) => {
        return response.sort((a, b) => {
          return a.progress_point > b.progress_point ? 1 : -1;
        });
      },
    }),

    progressPointUpdate: build.mutation<
      ProgressPointUpdateApiResponse,
      ProgressPointUpdate
    >({
      query: (progressPoint) => ({
        url: `${PROGRESS_POINTS_BASE_URL}/update_progress/`,
        method: "PUT",
        body: progressPoint,
      }),
    }),

    getAllGroupedProgressPoints: build.query<GroupedProgressPoints, void>({
      query: () => ({
        url: `${PROGRESS_POINTS_BASE_URL}/get_all_grouped_progress_points/`,
      }),
      transformResponse: (response: GroupedProgressPoints) => {
        const sortedResponse: GroupedProgressPoints = {};
        Object.keys(response).forEach((key) => {
          sortedResponse[key] = response[key]
            .slice()
            .sort((a, b) => a.progress_point - b.progress_point);
        });
        return sortedResponse;
      },
    }),

    getAllGroupedMaintenanceProgressPoints: build.query<
      GroupedProgressPoints,
      void
    >({
      query: () => ({
        url: `${PROGRESS_POINTS_BASE_URL}/get_all_grouped_maintenance_progress_points/`,
      }),
      transformResponse: (response: GroupedProgressPoints) => {
        const sortedResponse: GroupedProgressPoints = {};
        Object.keys(response).forEach((key) => {
          sortedResponse[key] = response[key]
            .slice()
            .sort((a, b) => a.progress_point - b.progress_point);
        });
        return sortedResponse;
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetProgressPointsByPidQuery,
  useProgressPointUpdateMutation,
  useGetAllGroupedProgressPointsQuery,
  useGetAllGroupedMaintenanceProgressPointsQuery,
} = progressPointsApi;
